import { usePageMeta } from '../hooks/usePageMeta';

export default function NotFound() {
    usePageMeta({
      title: 'Page Not Found | Global Educational Consultants',
      description: 'The page you requested could not be found.',
      noindex: true,
    });
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-5xl md:text-5xl font-semibold text-gray-100">404</h1>
        <h1 className="text-2xl md:text-3xl font-semibold mt-6">wrong way kiddo</h1>
      </div>
    );
  }
